// extracted by mini-css-extract-plugin
export default {"title":"RequestingSignatureModal_title__lnk3N","body":"RequestingSignatureModal_body__jjt1G"};